<app-horizontal-wrapper
  *ngIf="options2.length > 0 || showWhenEmpty"
  [type]="type"
  [label]="label"
  [alignRight]="alignRight"
  [required]="control | isRequired"
  [col3]="col3"
  [marginBottom]="!inTable && !isReadOnly && marginBottom"
  [contentPadding]="isReadOnly && !inTable"
>
  <div class="{{ col3 ? 'col-lg-5' : 'col-lg-12' }}" *ngIf="!isReadOnly">
    <div *ngIf="!modal && !inTable">
      <div class="input-group">
        <ng-select
          [labelForId]="id"
          [appendTo]="isInModal ? 'ngb-modal-window' : appendTo ? appendTo : ''"
          (remove)="onRemove($event)"
          [minTermLength]="3"
          [virtualScroll]="virtualScroll"
          [selectOnTab]="true"
          class="form-control"
          [typeahead]="input$"
          [items]="options2"
          [loading]="loading"
          bindLabel="name"
          bindValue="id"
          [formControl]="control"
          [dropdownPosition]="dropdownPosition"
          [clearable]="clearable"
          (clear)="onClearClick()"
          [hideSelected]="hideSelectedOption"
          (change)="change($event)"
          (add)="log($event)"
        >
          <!--TODO: template  as content-->
          <!--<div #optionContent>
                        <ng-content select="[option-template]">

                        </ng-content>
                    </div>-->
          <ng-template ng-option-tmp let-item="item">
            <ng-container
              [ngTemplateOutlet]="optionTemplate ?? defaultOption"
              [ngTemplateOutletContext]="{ $implicit: item, item: item }"
            >
            </ng-container>
          </ng-template>
        </ng-select>
        <span class="input-group-text" *ngIf="!control.disabled && ((showDetails && control.value) || showAdd)">
          <i
            *ngIf="showDetails && control.value"
            class="fa-solid fa-magnifying-glass text-secundary me-2 pe-1"
            [title]="detailsTitle"
          ></i>
          <i
            *ngIf="showAdd"
            class="fa-solid fa-circle-plus text-success"
            [title]="addTitle"
            (click)="addNew()"
          ></i>
        </span>
        <span class="input-group-text" *ngIf="!control.disabled && showEdit">
          <i
            class="fa-solid fa-pencil text-secondary bnt-add"
            [title]="editTitle"
            (click)="edit()"
          ></i>
        </span>
      </div>
    </div>
    <div *ngIf="modal && !inTable" class="input-group">
      <ng-select
        [dropdownPosition]="dropdownPosition"
        [appendTo]="isInModal ? 'ngb-modal-window' : appendTo ? appendTo : ''"
        (remove)="onRemove($event)"
        [minTermLength]="3"
        [virtualScroll]="virtualScroll"
        [selectOnTab]="true"
        class="form-control"
        [typeahead]="input$"
        [items]="options2"
        bindLabel="name"
        bindValue="id"
        [formControl]="control"
        [clearable]="clearable"
        (clear)="onClearClick()"
        [hideSelected]="hideSelectedOption"
      >
        <ng-template ng-option-tmp let-item="item">
          <ng-container
            [ngTemplateOutlet]="optionTemplate ?? defaultOption"
            [ngTemplateOutletContext]="{ $implicit: item, item: item }"
          >
          </ng-container>
        </ng-template>
      </ng-select>

      <span class="input-group-text">
        <a (click)="open(content)">
          <i class="fa-solid fa-circle-info text-primary"></i>
        </a>
      </span>
    </div>
    <div *ngIf="inTable">
      <div class="input-group">
        <ng-select
          [dropdownPosition]="dropdownPosition"
          [labelForId]="id"
          [appendTo]="isInModal ? 'ngb-modal-window' : appendTo ? appendTo : ''"
          (remove)="onRemove($event)"
          [minTermLength]="3"
          [virtualScroll]="virtualScroll"
          [selectOnTab]="true"
          class="form-control in-table text-sm"
          [typeahead]="input$"
          [items]="options2"
          bindLabel="name"
          bindValue="id"
          [formControl]="control"
          [clearable]="clearable"
          (clear)="onClearClick()"
          [hideSelected]="hideSelectedOption"
          (change)="change($event)"
          (add)="log($event)"
        >
          <ng-template ng-option-tmp let-item="item">
            <ng-container
              [ngTemplateOutlet]="optionTemplate ?? defaultOption"
              [ngTemplateOutletContext]="{ $implicit: item, item: item }"
            >
            </ng-container>
          </ng-template>
          <ng-template *ngIf="labelTemplate" ng-label-tmp let-item="item">
            <ng-container
              [ngTemplateOutlet]="labelTemplate"
              [ngTemplateOutletContext]="{ $implicit: item, item: item }"
            >
            </ng-container>
          </ng-template>
        </ng-select>
        <span class="input-group-text px-2" *ngIf="!control.disabled && ((showDetails && control.value) || showAdd)">
          <i
            *ngIf="showDetails && control.value"
            class="fa-solid fa-magnifying-glass text-secundary me-2 pe-1"
            [title]="detailsTitle"
          ></i>
          <i
            *ngIf="showAdd"
            class="fa-solid fa-circle-plus text-success"
            [title]="addTitle"
            (click)="addNew()"
          ></i>
        </span>
        <span class="input-group-text px-2" *ngIf="!control.disabled && showEdit">
          <i
            class="fa-solid fa-pencil text-secondary bnt-add"
            [title]="editTitle"
            (click)="edit()"
          ></i>
        </span>
      </div>
    </div>
    <app-validator [control]="control" [label]="label"></app-validator>
  </div>
  <div class="{{ col3 ? 'col-lg-5' : 'col-lg-12' }}" *ngIf="isReadOnly">
    {{ readOnlyValue }}
  </div>
</app-horizontal-wrapper>

<ng-template #content let-modal>
  <app-modal>
    <ng-container modal-title>{{ modalTitle }}</ng-container>
    <ng-container modal-body><ng-content></ng-content></ng-container>
  </app-modal>
</ng-template>

<ng-template #defaultOption let-item="item">
  <div [style.white-space]="'normal'" [style.overflow-wrap]="'break-word'">
    <span class="ng-option-label" [title]="item.name" [ngStyle]="item.style ?? {}">{{
      item.name
    }}</span>
  </div>
</ng-template>
